import api from "@/api/axios";

const BOT_ENDPOINT = "/bot/initial-sync";

export const triggerMessageBotInitialSync = () => api.post(BOT_ENDPOINT);

/**
 * Die Kategorien und Kanäle, die der Discord-Server gerade führt.
 *
 * ⚠️ Kann 502 liefern (Bot nicht erreichbar — der Regelfall in der
 * Entwicklungsumgebung) oder 503 (Bot da, Gateway-Sitzung noch nicht
 * aufgebaut). Beides ist ein Grund, der ausgeschrieben gehört, und kein
 * Anlass, die Liste leer zu zeigen: „keine Kategorien" wäre eine Aussage
 * über Discord, die hier niemand getroffen hat.
 */
export const getBotKategorien = () => api.get("/bot/categories");
